import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import MapClickHandler from './MapClickHandler';

// Interactive Map Component
const LocationMap = ({ onLocationSelect, selectedLocation, center = [52.5200, 13.4050], zoom = 10 }) => {
  const [mapKey, setMapKey] = useState(0);

  // Reset map when location changes
  useEffect(() => {
    setMapKey(prev => prev + 1);
  }, [selectedLocation]);

  return (
    <div className="w-full h-64 border border-gray-300 rounded-lg overflow-hidden">
      <MapContainer
        key={mapKey}
        center={selectedLocation ? [selectedLocation.latitude, selectedLocation.longitude] : center}
        zoom={selectedLocation ? 15 : zoom}
        style={{ height: '100%', width: '100%' }}
        className="z-0"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapClickHandler onLocationSelect={onLocationSelect} />
        {selectedLocation && (
          <Marker position={[selectedLocation.latitude, selectedLocation.longitude]}>
            <Popup>
              Position: {selectedLocation.latitude.toFixed(4)}, {selectedLocation.longitude.toFixed(4)}
            </Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};

export default LocationMap;
